import { TextField, Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel, Radio, RadioGroup, Button, IconButton } from '@mui/material';
import { Settings, Trash2 } from 'lucide-react'; // keep icons or replace with @mui/icons-material
import { useState } from 'react';

export default function FormField({ field, isSelected, onClick, onUpdate, onDelete }) {
  const renderFieldInput = () => {
    switch (field.type) {
      case 'text':
      case 'email':
      case 'number':
        return (
          <TextField
            type={field.type}
            placeholder={field.placeholder}
            disabled
            fullWidth
            size="small"
            data-testid={`field-input-${field.id}`}
          />
        );

      case 'textarea':
        return (
          <TextField
            placeholder={field.placeholder}
            disabled
            fullWidth
            size="small"
            multiline
            rows={3}
            data-testid={`field-input-${field.id}`}
          />
        );

      case 'select':
        return (
          <FormControl fullWidth size="small" disabled>
            <InputLabel>{field.placeholder || 'Select an option'}</InputLabel>
            <Select
              value=""
              data-testid={`field-input-${field.id}`}
            >
              {field.options?.map((option, index) => (
                <MenuItem key={index} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case 'radio':
        return (
          <RadioGroup data-testid={`field-input-${field.id}`}>
            {field.options?.map((option, index) => (
              <FormControlLabel
                key={index}
                value={option}
                control={<Radio disabled />}
                label={option}
              />
            ))}
          </RadioGroup>
        );

      case 'checkbox':
        if (field.options && field.options.length > 1) {
          return (
            <div data-testid={`field-input-${field.id}`}>
              {field.options.map((option, index) => (
                <FormControlLabel
                  key={index}
                  control={<Checkbox disabled />}
                  label={option}
                />
              ))}
            </div>
          );
        } else {
          return (
            <FormControlLabel
              control={<Checkbox disabled />}
              label={field.options?.[0] || field.label}
              data-testid={`field-input-${field.id}`}
            />
          );
        }

      case 'date':
        return (
          <TextField
            type="date"
            disabled
            fullWidth
            size="small"
            data-testid={`field-input-${field.id}`}
          />
        );

      case 'file':
        return (
          <TextField
            type="file"
            disabled
            fullWidth
            size="small"
            data-testid={`field-input-${field.id}`}
          />
        );

      default:
        return (
          <TextField
            type="text"
            placeholder={field.placeholder}
            disabled
            fullWidth
            size="small"
            data-testid={`field-input-${field.id}`}
          />
        );
    }
  };

  return (
    <div
      style={{ padding: '16px', position: 'relative', cursor: 'pointer' }}
      onClick={onClick}
      data-testid={`form-field-${field.id}`}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ flex: 1 }}>
          <label data-testid={`field-label-${field.id}`} style={{ display: 'block', fontWeight: 500, marginBottom: 4 }}>
            {field.label}
            {field.required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
          </label>
          {renderFieldInput()}
          {field.unique && (
            <p style={{ fontSize: '12px', color: '#1976d2', marginTop: 4 }}>Unique values only</p>
          )}
        </div>
        <div style={{ marginLeft: 8, opacity: isSelected ? 1 : 0.5 }}>
          <IconButton size="small" onClick={(e) => { e.stopPropagation(); onClick(); }} data-testid={`button-edit-field-${field.id}`}>
            <Settings size={16} />
          </IconButton>
          <IconButton size="small" onClick={(e) => { e.stopPropagation(); onDelete(); }} data-testid={`button-delete-field-${field.id}`}>
            <Trash2 size={16} />
          </IconButton>
        </div>
      </div>
    </div>
  );
}
